import axios from "axios";
import { backend_url } from "../../constants";
import { AXIOS_CONFIG } from "../../utils/api";
import { Endpoints } from "./endpoints";

export type Summary = {
  eventType: number;
  description: string;
  count: number;
  modalTitle?: string;
  modalDescription?: string;
  clientIds?: number[];
};

export interface TaxProSummary {
  lastUpdated: string;
  summary: Summary[];
}

/**
 * Fetch summary info
 * @returns a summary of the tax pro's info
 */
export const fetchSummaryInfo = async (): Promise<TaxProSummary> => {
  try {
    const response = await axios.get<{ content: TaxProSummary }>(
      `${backend_url}/${Endpoints.summary}`,
      {
        ...AXIOS_CONFIG,
      }
    );
    return response.data.content;
  } catch (error) {
    throw new Error("Failed to fetch tax pro info");
  }
};
